import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: { requiresVisitor: true },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
    meta: { requiresVisitor: true },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/applications',
    name: 'UserApplications',
    component: () => import(/* webpackChunkName: "applications" */ '../views/UserApplications.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/apply/:id',
    name: 'Apply',
    component: () => import(/* webpackChunkName: "apply" */ '../views/Apply.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/vacant-jobs',
    name: 'VacantJobs',
    component: () => import(/* webpackChunkName: "vacant-jobs" */ '../views/VacantJobs.vue'),
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: () => import(/* webpackChunkName: "verify-email" */ '../views/VerifyEmail.vue'),
  },
  {
    path: '/forgotten-password',
    name: 'ForgottenPassword',
    component: () => import(/* webpackChunkName: "forgotten-password" */ '../views/ForgottenPassword.vue'),
    meta: { requiresVisitor: true },
  },
  // {
  //   path: '*',
  //   redirect: '/',
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!store.getters.isAuth && to.matched.some((record) => record.meta.requiresAuth)) {
    next({ name: 'Login', query: { redirect: to.path } });
  } else if (store.getters.isAuth && to.matched.some((record) => record.meta.requiresVisitor)) {
    next('/');
  } else {
    next();
  }
});

export default router;
